const normalizeError = (error) => {
  if (!error) {
    return { error: { message: 'Unknown repository error' } }
  }

  if (error.response) {
    return {
      error: {
        status: error.response.status,
        data: error.response.data,
        message: error.response.data?.message || error.message || 'Request failed'
      }
    }
  }

  return {
    error: {
      message: error.message || 'Request failed'
    }
  }
}

export default $axios => (resource, subresource) => ({
  index (x) {
    return $axios
      .$get(`api/${resource}`, { params: x })
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  subIndex (id, x) {
    return $axios
      .$get(`api/${resource}/${id}/${subresource}`, { params: x })
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  show (id, x) {
    return $axios
      .$get(`api/${resource}/${id}`, { params: x })
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  create (payload) {
    return $axios
      .$post(`api/${resource}`, payload)
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  subCreate (parentId, payload) {
    return $axios
      .$post(`api/${resource}/${parentId}/${subresource}`, payload)
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  subCreateFile (parentId, payload, fileResource = 'documents') {
    return $axios
      .$post(`api/${resource}/${parentId}/${fileResource}`, payload)
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  update ({ id, payload }) {
    return $axios
      .$put(`api/${resource}/${id}`, payload)
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  subMassUpdate (parentId, childId, payload) {
    return $axios
      .$put(`api/${resource}/${parentId}/${subresource}`, payload)
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  subUpdate (parentId, childId, payload) {
    return $axios
      .$put(`api/${resource}/${parentId}/${subresource}/${childId}`, payload)
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  delete (id, payload = null) {
    return $axios
      .$delete(`api/${resource}/${id}`, payload ? { data: payload } : undefined)
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  subDelete (parentId, childId, payload = null) {
    return $axios
      .$delete(`api/${resource}/${parentId}/${subresource}/${childId}`, payload ? { data: payload } : undefined)
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  print (x) {
    return $axios
      .$get(`api/${resource}`, { params: x })
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  postPrint (payload) {
    return $axios
      .$post('api/postTunnel', payload)
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  subPrint (id, x) {
    return $axios
      .$get(`api/${resource}/${id}/${subresource}`, { params: x })
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  showPrint (id, x) {
    return $axios
      .$get(`api/${resource}/${id}`, { params: x })
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  export (x) {
    return $axios
      .$get(`api/${resource}`, { params: x })
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  subExport (id, x) {
    return $axios
      .$get(`api/${resource}/${id}/${subresource}`, { params: x })
      .then(results => results)
      .catch(error => normalizeError(error))
  },

  showExport (id, x) {
    return $axios
      .$get(`api/${resource}/${id}`, { params: x })
      .then(results => results)
      .catch(error => normalizeError(error))
  }
})
